import { makeStyles } from '@material-ui/core';

export default makeStyles({
  markerWrapper: {
    position: 'absolute',
    transform: 'translate(-50%, -100%)',
  },
});
